import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2whx95n6vnccj">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-blue/85 md:text-3xl" data-id="element-1" data-mp="28te2fc3h77mk">
      🌿 Tu próxima consulta empieza con criterio, no con dudas.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Kit Maestro de Biodescodificación',
      content_type: 'product',
      value: 24990,
      currency: 'ARS'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-blueMist selection:text-brand-blue" data-id="element-2" data-mp="5yjsutqtdfe">
      <UrgencyBanner data-id="element-3" data-mp="2zm4y4lnitf2c" />
      <main data-id="element-4" data-mp="2zmo6bandcp36">
        <Hero data-id="element-5" data-mp="2zmwl5831y4h0" />
        <PackContents data-id="element-6" data-mp="2zng2amkvootz" />
        <InitialTestimonials data-id="element-7" data-mp="33m5b01uz1i7a" />
        <PainPoints data-id="element-8" data-mp="33ngee0ki8nxv" />
        <LaunchOffer data-id="element-9" data-mp="33myl9ct52pu6" />
        <MoreTestimonials data-id="element-10" data-mp="38lromcepp0gm" />
        <FAQ data-id="element-11" data-mp="38l8f9k34nke7" />
        <CostComparison data-id="element-12" data-mp="38kqbm2e4y3w9" />
        <TransitionPhrase data-id="element-13" data-mp="38kgkgbhctqoz" />
        <EmotionalClose data-id="element-14" data-mp="3dkuuu06fhcq6" />
      </main>
      <Footer data-id="element-15" data-mp="3dlw727z6k59h" />
      <FloatingNotification data-id="element-16" data-mp="3dlnt0crbmtwp" />
    </div>;
}